site.accordion = site.accordion || {};
site.accordion = $.extend({
	init: function () {
		var $accordion = $('section.accordion');
		$accordion.each(function () {
			var $this = $(this);
			$('>*:not(:first-child)', $this).wrapAll('<div class="wrap" />');
			$('>:first-child', $this).wrapInner('<a href="#">');
			$('>:first-child a', $this).on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				$this.toggleClass('open');

				if ($this.hasClass('open')) {
					site.accordion.addTimeoutClass($this, 'opening');
				}
				else {
					site.accordion.addTimeoutClass($this, 'closing');
				}
			});
		}).on('click', function(e) {
			var $this = $(this);
			if (!$this.hasClass('open')) {
				e.preventDefault();
				e.stopPropagation();
			}

			if ($this.attr('class').indexOf('open') === -1 && $(e.target).prop('tagName') !== 'A') {
				$this.find('>:first-child a').trigger('click');
			}
		});

		site.accordion.initMaxHeight();
		$(window).load(function() {
			setTimeout(function() {
				$accordion.addClass('ready');
			}, 1);
			site.accordion.hashOpen();
		});
	},

	addTimeoutClass: function (element, className, time) {
		time = (time === undefined) ? 400 : time;
		element.addClass(className);
		setTimeout(function () {
			element.removeClass(className);
		}, time);
	},

	initMaxHeight: function () {
		if ($('section.accordion .wrap').length === 0) return;
		$(window).load(function() {
			site.accordion.setHeight();
		});
		$(window).resize(function () {
			site.accordion.setHeight();
		});
	},

	setHeight: function () {
		var $accordion = $('section.accordion');

		$accordion.each(function() {
			var $this = $(this),
				isOpen = $this.hasClass('open');

			$this.addClass('open');
			$('.wrap', $this).each(function () {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});

			if (!isOpen) {
				$this.removeClass('open');
			}
		});
	},

	getOpenOffset: function() {
		return 30;
	},

	hashOpen: function() {
		var $accordion = $('section.accordion');
		if ($accordion.length > 0 && location.hash.length > 0 && !$('body').hasClass('admin')) {
			var $open = $accordion.filter(location.hash);
			$open.addClass('open');

			$('body,html').animate({
				scrollTop: $open.offset().top - site.accordion.getOpenOffset()
			});
		}
	}
}, site.accordion);

site.inits.push('site.accordion.init()');
